import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  videoContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  audioStyles: {
    backgroundColor: colors.darkPurpleBlue,
    justifyContent: 'center',
    alignItems: 'center',
  },
  questionStyles: {
    backgroundColor: colors.darkPurpleBlue,
    justifyContent: 'center',
    alignItems: 'center',
  },
  disabled: {
    opacity: 0.3,
  },
  none: {
    display: 'none',
  },
  center: { justifyContent: 'center', alignItems: 'center' },
});

export default styles;
